<div mat-dialog-content>
    <!-- <mat-table fxFlex="1 1 auto" #sourceFilterTable [dataSource]="columnDataSource" class="">
        <ng-container matColumnDef="column">
            <mat-header-cell *matHeaderCellDef>Column</mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.label}}
            </mat-cell>
        </ng-container>
        <mat-row *matRowDef="let row; columns: ['column']">
        </mat-row>
    </mat-table> -->
    <p-table #dt [columns]="[{field: 'label'}]" [value]="columns" [scrollable]="true" scrollHeight="45vh" selectionMode="single" [(selection)]="data.selectedColumn" class="liquitics-compact-table">
        <ng-template pTemplate="caption">
            <div style="text-align: left">
                <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
                <input type="text" pInputText size="50" placeholder="Search"
                    (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
            </div>
        </ng-template>
        <ng-template pTemplate="colgroup" let-columns>
            <colgroup>
                <col *ngFor="let col of columns" style="width:400px">
            </colgroup>
        </ng-template>
        <!-- <ng-template pTemplate="header" let-columns>
            <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                    {{col.header}}
                    <p-sortIcon [field]="col.field"></p-sortIcon>
                </th>
            </tr>
            <tr>
                <th *ngFor="let col of columns" [ngSwitch]="col.field">
                    <input pInputText type="text"
                        (input)="dt.filter($event.target.value, col.field, col.filterMatchMode)">
                </th>
            </tr>
        </ng-template> -->
        <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr [pSelectableRow]="rowData">
                <td *ngFor="let col of columns" style="text-align:left">
                    {{rowData.label}}
                </td>
            </tr>
        </ng-template>
    </p-table>

</div>
<mat-dialog-actions  align="end">
    <button mat-button (click)="onNoClick()">Cancel</button>
    <button mat-button [mat-dialog-close]="data.selectedColumn" cdkFocusInitial>Ok</button>
</mat-dialog-actions>